import { render, staticRenderFns } from "./pop-view.vue?vue&type=template&id=2ac7f1aa&scoped=true"
import script from "./pop-view.vue?vue&type=script&lang=js"
export * from "./pop-view.vue?vue&type=script&lang=js"
import style0 from "./pop-view.vue?vue&type=style&index=0&id=2ac7f1aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac7f1aa",
  null
  
)

export default component.exports